import { render, staticRenderFns } from "./AreaAdmin.vue?vue&type=template&id=2754022f&"
import script from "./AreaAdmin.vue?vue&type=script&lang=js&"
export * from "./AreaAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports